module.exports = __webpack_public_path__ + "static/media/bucina_temperatures.3beaa539.gif";